import React from 'react'

import { SubscriptionSteps } from '../../../common/types.js'
import { Cart, CartProps } from '../../components-hydrated/cart/cart.js'
import { PlanCards, PlanCardsProps } from '../../components-hydrated/plan-cards/plan-cards.js'
import { GridColumn } from '../../components/grid/grid-column.js'
import { Grid } from '../../components/grid/grid.js'
import { Progress, ProgressProps } from '../../components/progress/progress.js'
import { AuthProps, AuthStep } from '../../components/steps/authentication-step.js'
import { CreditCheckProps, CreditCheckStep } from '../../components/steps/credit-check-step.js'
import { SignProps, SignStep } from '../../components/steps/sign-step.js'
import { ValidationProps, ValidationStep } from '../../components/steps/validation-step.js'

export interface SubscriptionProps {
    step: SubscriptionSteps
    selectPlanProps?: PlanCardsProps
    authenticationProps?: AuthProps
    signProps?: SignProps
    creditCheckProps?: CreditCheckProps
    validationProps?: ValidationProps
    subscriptionUuid: string
    basketId: string
    countryTopDomain: string
    redirectUrl: string
    cartProps?: CartProps
    progressProps: ProgressProps
    mockStatusAsAuthenticated?: () => Promise<unknown>
    mockStatusAsSigned?: () => Promise<unknown>
    mockStatusAsCompleted?: () => Promise<unknown>
    isDebugEnabled?: boolean
    isCentered?: boolean
}

export const Subscription = (props: SubscriptionProps): JSX.Element => {
    const isPlansStep = props.step === SubscriptionSteps.PLANS
    const isAuthStep = props.step === SubscriptionSteps.AUTH
    const isSignStep = props.step === SubscriptionSteps.SIGN
    const isCreditCheckStep = props.step === SubscriptionSteps.CREDIT_CHECK
    const isValidationStep = props.step === SubscriptionSteps.VALIDATION

    return (
        <div className="text">
            {isSignStep && <Progress {...props.progressProps} />}
            <Grid align={props.isCentered ? ['center-xs'] : undefined} className="text__margin-double">
                {/* {props.isDebugEnabled && (
                    <GridColumn offset={['md-1']} width={['md-10']}>
                        <DemoUrls
                            basketId={props.basketId}
                            redirectUrl={props.redirectUrl}
                            mockStatusAsAuthenticated={props.mockStatusAsAuthenticated}
                            mockStatusAsSigned={props.mockStatusAsSigned}
                            mockStatusAsCompleted={props.mockStatusAsCompleted}
                        />
                    </GridColumn>
                )} */}
                <GridColumn offset={!props.isCentered ? ['md-1'] : undefined} width={['md-10', 'xl-6']}>
                    {(props.selectPlanProps && isPlansStep && <PlanCards {...props.selectPlanProps} />) ||
                        (props.authenticationProps && isAuthStep && (
                            <AuthStep {...props.authenticationProps} isCentered={props.isCentered} />
                        )) ||
                        (props.signProps && isSignStep && <SignStep {...props.signProps} />) ||
                        (props.creditCheckProps && isCreditCheckStep && (
                            <CreditCheckStep {...props.creditCheckProps} />
                        )) ||
                        (props.validationProps && isValidationStep && <ValidationStep {...props.validationProps} />)}
                </GridColumn>

                {props.cartProps &&
                    (props.cartProps.alwaysFixed ? (
                        <Cart {...props.cartProps} />
                    ) : (
                        <GridColumn offset={['md-1']} width={['md-10', 'xl-4']}>
                            <Cart {...props.cartProps} />
                        </GridColumn>
                    ))}
            </Grid>
        </div>
    )
}
